module.exports = __webpack_public_path__ + "879b3c63af1d10e0ada341525197cb7d.MP3";